import clsx from 'clsx';
import React from 'react';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { FaAngleDown } from 'react-icons/fa';

import { useStyles } from './styles';

export interface ICustomDropdown {
  open: boolean;
  text: string;
  labels: string[];
  toggle: any;
  onClickItem: any;
  paddingHorizontal?: number;
  showBorder?: boolean;
  labelFontsize?: number;
  labelFontWeight?: 'bold' | 'normal';
  marginBottom?: number;
  marginTop?: number;
  iconStyle?: React.CSSProperties;
  iconSize?: number;
  onMouseEnter?: any;
  onMouseLeave?: any;
}

const CustomDropdown: React.FC<ICustomDropdown> = ({
  open,
  text,
  toggle,
  labels,
  onClickItem,
  paddingHorizontal,
  showBorder,
  labelFontsize,
  labelFontWeight,
  marginBottom,
  marginTop,
  iconStyle,
  iconSize,
  onMouseEnter,
  onMouseLeave,
}) => {
  const classes = useStyles();

  return (
    <Dropdown className={classes.container} isOpen={open} toggle={toggle}>
      <DropdownToggle
        className={clsx(classes.toggle, {
          [classes.toggleSelected]: open,
        })}
        // caret
        tag="span"
        data-toggle="dropdown"
        onMouseEnter={onMouseEnter}
        // onMouseLeave={onMouseLeave}
        // onMouseOut={onMouseLeave}
        style={{
          paddingLeft: paddingHorizontal,
          paddingRight: paddingHorizontal,
          borderWidth: showBorder ? 1 : 0,
          fontSize: labelFontsize,
          fontWeight: labelFontWeight,
          marginBottom,
          marginTop,
        }}
      >
        {text}
        <div className={classes.iconContainer}>
          <FaAngleDown size={iconSize || 24} style={iconStyle} />
        </div>
      </DropdownToggle>
      <DropdownMenu container="body" onMouseLeave={onMouseLeave}>
        {labels.map((label, idx) => (
          <DropdownItem
            className={classes.item}
            key={idx}
            onClick={onClickItem}
          >
            {label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default CustomDropdown;
